/**
 * Filterable fields for Template to render document
 */
export enum ReportDocumentTemplateIndexedFields {
  Id = "_id",
  Text = "#text",
  AccountId = "AccountId",
  CreatedDate = "createdDate",
  EntityId = "entityId",
  FlowId = "flowId",
  IsActive = "isActive",
  Name = "name",
  ObjectStatusId = "objectStatusId",
  StoredProcedures = "StoredProcedures"
}
